export enum EAllowedOperation {
  READ = 'READ',
  READ_WRITE = 'READ_WRITE',
}

export enum ENoteEntityType {
  PEOPLE = 'PEOPLE',
  ORGANIZATION = 'ORGANIZATION',
  WORKSHOP = 'WORKSHOP',
  EVENT = 'EVENT',
  ELC = 'ELC',
}

export type TNoteDB = {
  resourceId: string;
  note: string;
  isPrivate: boolean;
  createdDate: string;
  createdByName: string;
  updatedDate: string;
  updatedByName: string;
  allowedOperation: EAllowedOperation;
};

export type TNoteUI = {
  resourceId: string;
  note: string;
  isPrivate: boolean;
  createdDate: string;
  createdByName: string;
  updatedDate: string;
  updatedByName: string;
  allowedOperation: EAllowedOperation;
};

export type TCreateNoteUI = {
  note: string;
  id: string;
  entityType: ENoteEntityType;
  isPrivate: boolean;
};

export type TCreateNoteDB = {
  note: string;
  id: string;
  entityType: ENoteEntityType;
  isPrivate: boolean;
};

export type TUpdateNoteUI = {
  resourceId: string;
  note: string;
  isPrivate: boolean;
};

export type TUpdateNoteDB = {
  note: string;
  isPrivate: boolean;
};

export type TDeleteNoteUI = {
  resourceId: string;
};

export type TGetNotesParams = {
  entityType: ENoteEntityType;
  entityId: string;
};
